import { Component, HostListener, OnInit } from '@angular/core';
import { ClientService } from 'src/app/services/client.service';

import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import { AddressOriginComponent } from 'src/app/cell-renderer/address-origin/address-origin.component';
import { AddressDestinationComponent } from 'src/app/cell-renderer/address-destination/address-destination.component';
import { ActionsComponent } from 'src/app/cell-renderer/actions/actions.component';
import { LoadingGridComponent } from 'src/app/cell-renderer/loading-grid/loading-grid.component';
import { UtilsService } from 'src/app/services/utils.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpEventType } from '@angular/common/http';
import Swal from 'sweetalert2';

declare const $: any

@Component({
    selector: 'app-client-list',
    templateUrl: './client-list.component.html',
    styleUrls: ['./client-list.component.css']
})
export class ClientListComponent {
    constructor(private api: ClientService, private utils: UtilsService, private spinner: NgxSpinnerService) { }
    address: any = []

    private importing = false;

    public actionsOpen = false;

    columnDefs = [
        { headerName: "Accion", width: 95, cellRenderer: ActionsComponent, cellRendererParams: { parent: this, url_edit: "/client/update/", module: "Clientes", singular_module: "Cliente" } },
        { field: 'name', headerName: "Nombre del Client", flex: 1 },
        { field: 'rfc', width: 150, headerName: "RFC" },
        { field: 'postal_code', width: 150, headerName: "Codigo Postal" },
        { field: 'local_regime', headerName: "Regimen Local" },
        { field: 'email', headerName: "Correo Electronico" },
        // { field: 'address_origin', headerName: "Direcciones de Origen", cellRenderer: AddressOriginComponent, cellRendererParams: { parent: this, event_text: "Origen" } },
        // { field: 'address_destination', headerName: "Direcciones de Destino", cellRenderer: AddressDestinationComponent, cellRendererParams: { parent: this, event_text: "Destino" } },

    ];

    public loadingCellRenderer: any = LoadingGridComponent;
    public loadingCellRendererParams: any = {
        loadingMessage: 'Espere un momento...',
    };

    public defaultColDef = {
        sortable: true,
        filter: true,
    };

    private gridApi!: GridApi;

    public rowData: any = [];

    ngOnInit(): void {
    }

    event_text = ''

    editButtonClick(addressArray: any, text_event: any) {
        this.address = addressArray
        this.event_text = text_event
        $("#AddressDestination").modal("show")
    }

    onGridReady(params: any) {
        this.spinner.show()
        this.api.listClient().subscribe((resp) => {
            this.rowData = resp;
            this.spinner.hide()
        })
    }

    toggleActionsDropdown() {
        this.actionsOpen = !this.actionsOpen;
    }

    closeActionsDropdown() {
        this.actionsOpen = false;
    }

    @HostListener('document:click')
    onDocumentClick() {
        this.closeActionsDropdown();
    }

    exportFiscalRegimesCsv() {
        this.spinner.show();
        this.api.getFiscalRegimes().subscribe({
            next: (resp: any) => {
                this.spinner.hide();

                const items: Array<{ id?: number; key?: string; description?: string }> = Array.isArray(resp) ? resp : [];
                const headers = ['id', 'key', 'description'];
                const rows = items.map((i) => [i?.id ?? '', i?.key ?? '', i?.description ?? '']);
                const blob = this.createCsvBlob(headers, rows, ';');

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `fiscal-regimes-export-${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')}.csv`;
                a.click();
                window.URL.revokeObjectURL(url);
            },
            error: () => {
                this.spinner.hide();
                this.utils.alertSwal({ title: 'Error', text: 'No se pudo exportar el régimen fiscal', icon: 'error' });
            }
        })
    }

    exportCfdiUsesCsv() {
        this.spinner.show();
        this.api.getCfdiUses().subscribe({
            next: (resp: any) => {
                this.spinner.hide();

                const items: Array<{ id?: number; key?: string; description?: string }> = Array.isArray(resp) ? resp : [];
                const headers = ['id', 'key', 'description'];
                const rows = items.map((i) => [i?.id ?? '', i?.key ?? '', i?.description ?? '']);
                const blob = this.createCsvBlob(headers, rows, ';');

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `cfdi-uses-export-${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')}.csv`;
                a.click();
                window.URL.revokeObjectURL(url);
            },
            error: () => {
                this.spinner.hide();
                this.utils.alertSwal({ title: 'Error', text: 'No se pudo exportar el uso CFDI', icon: 'error' });
            }
        })
    }

    private createCsvBlob(headers: string[], rows: any[][], delimiter: string) {
        const escape = (value: any) => {
            const s = value === null || value === undefined ? '' : String(value);
            const needsQuotes = s.includes('"') || s.includes('\n') || s.includes('\r') || s.includes(delimiter);
            const escaped = s.replace(/"/g, '""');
            return needsQuotes ? `"${escaped}"` : escaped;
        };

        const headerLine = headers.map(escape).join(delimiter);
        const bodyLines = rows.map((r) => r.map(escape).join(delimiter));
        const content = [headerLine, ...bodyLines].join('\n');
        return new Blob([content], { type: 'text/csv;charset=utf-8' });
    }

    exportCsv() {
        this.spinner.show();
        this.api.exportClients().subscribe({
            next: (blob: any) => {
                this.spinner.hide();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `clients-export-${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')}.csv`;
                a.click();
                window.URL.revokeObjectURL(url);
            },
            error: () => {
                this.spinner.hide();
                this.utils.alertSwal({ title: 'Error', text: 'No se pudo exportar el CSV', icon: 'error' });
            }
        })
    }

    openCsvPicker(input: HTMLInputElement) {
        if (this.importing) {
            return;
        }
        this.closeActionsDropdown();
        input.value = '';
        input.click();
    }

    onCsvSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input?.files?.[0];
        if (!file) {
            return;
        }
        this.importCsv(file);
    }

    private importCsv(file: File) {
        this.importing = true;

        let lastPercent = 0;
        Swal.fire({
            title: 'Importando clientes',
            html: `
                <div style="text-align:left">
                  <div style="margin-bottom:8px">Subiendo archivo y procesando…</div>
                  <div style="width:100%;background:#e9ecef;border-radius:6px;overflow:hidden;height:12px">
                    <div id="importProgressBar" style="width:0%;height:12px;background:#0d6efd"></div>
                  </div>
                  <div id="importProgressText" style="margin-top:8px;font-size:12px;color:#6c757d">0%</div>
                </div>
            `,
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        this.api.importClients(file).subscribe({
            next: (event) => {
                if (event.type === HttpEventType.UploadProgress) {
                    const total = event.total ?? 0;
                    const loaded = event.loaded ?? 0;
                    const percent = total > 0 ? Math.round((loaded / total) * 100) : 0;
                    lastPercent = percent;
                    const bar = document.getElementById('importProgressBar');
                    const txt = document.getElementById('importProgressText');
                    if (bar) bar.style.width = `${percent}%`;
                    if (txt) txt.textContent = `${percent}%`;
                }

                if (event.type === HttpEventType.Response) {
                    const resp: any = event.body;
                    Swal.close();

                    const summary = resp?.summary;
                    const errors = resp?.errors ?? [];
                    const inserted = summary?.inserted ?? 0;
                    const updated = summary?.updated ?? 0;
                    const failed = summary?.failed ?? 0;

                    const html = `
                      <div style="text-align:left">
                        <div><strong>Insertados:</strong> ${inserted}</div>
                        <div><strong>Actualizados:</strong> ${updated}</div>
                        <div><strong>Fallidos:</strong> ${failed}</div>
                      </div>
                    `;

                    this.utils.alertSwal({
                        title: 'Importación finalizada',
                        text: '',
                        icon: failed > 0 ? 'warning' : 'success'
                    }).then(() => {
                        // no-op
                    });

                    // Mejor UX: mostrar summary con botones
                    Swal.fire({
                        title: 'Importación finalizada',
                        html,
                        icon: failed > 0 ? 'warning' : 'success',
                        showCancelButton: failed > 0,
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: failed > 0 ? 'Descargar errores' : undefined,
                    }).then((result) => {
                        if (result.dismiss === Swal.DismissReason.cancel && failed > 0) {
                            this.downloadJson(errors, 'client-import-errors.json');
                        }
                    });

                    this.onGridReady({});
                    this.importing = false;
                }
            },
            error: (error) => {
                Swal.close();
                this.importing = false;
                this.utils.alertSwal({ title: 'Error', text: String(error || 'Error al importar'), icon: 'error' });
            }
        });
    }

    private downloadJson(data: any, filename: string) {
        try {
            const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json;charset=utf-8' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (e) {
            // fallback: ignore
        }
    }
    actionDelete(id: number) {
        this.utils.alertSwalConfir({title:"Eliminación", text:"Esta seguro que desea eliminar el cliente seleccionado", icon: "warning", btn_confirm: "Elimniar"})
        .then((result) => {
            if(result.isConfirmed){
                this.spinner.show()
                this.api.deleteClient(id).subscribe((resp) => {
                    this.spinner.hide()
                    this.utils.alertSwal({title: "Operación Exitosa", text: "Se ha realizado la eliminacion de cliente de forma exitosa", icon: "success"})
                    this.onGridReady({})
                }, (error) => {
                    this.spinner.hide()
                    this.utils.alertSwal({title: "Error", text: "Se ha presentado un error al intentar eliminar el cliente", icon: "error"})
                })
                
            }
        })
    }
}
